export default {
  setIsLoading(state, { isLoading }) {
    state.isLoading = isLoading;
  },

  setIsAnnouncement(state, isAnnouncement = false) {
    state.routeLayout.isAnnouncement = isAnnouncement;
  },

  setIsExcel(state, { isExcel }) {
    state.routeLayout.isExcel = isExcel;
  },

  setIsBack(state, { isBack }) {
    state.routeLayout.isBack = isBack;
  },
  setProductBuyMove(state, productBuyMove = false) {
    state.productBuyMove = productBuyMove;
  },

  setIsHome(state, { isHome }) {
    state.routeLayout.isHome = isHome;
  },
  setInitMovePath(state, initMovePath = '') {
    state.initMovePath = initMovePath;
  },
  setLoginMovePath(state, loginMovePath = '') {
    state.loginMovePath = loginMovePath;
    // 260821 — 401 하드 리다이렉트·OAuth 풀 왕복(네이버/카카오 콜백)은 스토어가 리셋돼 복귀 경로가 유실됐다
    //   (교회 시연 "로그인했더니 메인으로 튕김"의 원인). 탭 단위 sessionStorage 미러로 리로드를 건너 전달 —
    //   소비처가 setLoginMovePath()로 클리어하면 여기도 지워져 양방향 소모가 유지된다. localStorage 영속은
    //   다음날 무관한 로그인까지 납치할 수 있어 금지.
    try {
      if (loginMovePath) sessionStorage.setItem('jump.loginMovePath', loginMovePath);
      else sessionStorage.removeItem('jump.loginMovePath');
    } catch (_) { /* storage 차단 시 종전(메모리 한정) 동작 */ }
  },
  setIsSmileShare(state, isSmileShare = false) {
    state.routeLayout.isSmileShare = isSmileShare;
  },

  setIsMemorialShare(state, isMemorialShare = false) {
    state.routeLayout.isMemorialShare = isMemorialShare;
  },

  setIsAnnouncementShare(state, isAnnouncementShare = false) {
    state.routeLayout.isAnnouncementShare = isAnnouncementShare;
  },

  setIsFuneralShare(state, isFuneralShare = false) {
    state.routeLayout.isFuneralShare = isFuneralShare;
  },

  setIsInvitationShare(state, isInvitationShare = false) {
    state.routeLayout.isInvitationShare = isInvitationShare;
  },

  setModalAlertComponents(state, { modalAlertComponents }) {
    state.modalAlertComponents = modalAlertComponents;
  },
  setModalComponents(state, { modalComponents }) {
    state.modalComponents = modalComponents;
  },
  setRouteLayout(
    state,
    {
      isHeader = undefined,
      isHeaderPrimary = undefined,
      titleName = undefined,
      isBack = undefined,
      isLike = undefined,
      isNav = undefined,
      isHome = undefined,
      isSearch = undefined,
      isGlass = undefined,
      isSearchHeader = undefined,
      isFilter = undefined,
      isShare = undefined,
      isFuneralShare = undefined,
      isFuneralKakaoShare = undefined,
      isAnnouncementShare = undefined,
      isAnnouncementKakaoShare = undefined,
      isSmileShare = undefined,
      isSmileKakaoShare = undefined,
      isInvitationShare = undefined,
      isInvitationKakaoShare = undefined,
      isBusinessLike = undefined,
      isBusinessSubscribe = undefined,
      isBusinessKakaoShare = undefined,
      isBusinessMarketingShare = undefined,
      isBusinessMarketingKakaoShare = undefined,
      isBusinessDonationShare = undefined,
      isBusinessDonationKakaoShare = undefined,
      isBusinessJobKakaoShare = undefined,
      isBusinessJobShare = undefined,
      isBusinessShare = undefined,
      isBizDetailShare = undefined,
      isMarketingShare = undefined,
      isMarketingKakaoShare = undefined,
      isMemorialShare = undefined,
      isMemorialKakaoShare = undefined,
      isExcel = undefined,
      subName = undefined,
      isBell = undefined,
      isSetting = undefined,
      isFooter = undefined,
      isPlus = undefined,
      isEdit = undefined,
      isDelete = undefined,
      isGreen = undefined
    }
  ) {
    state.routeLayout.isHeader = isHeader ?? false;
    state.routeLayout.isHeaderPrimary = isHeaderPrimary ?? false;
    state.routeLayout.titleName = titleName ?? false;
    state.routeLayout.isHome = isHome ?? false;
    state.routeLayout.isBack = isBack ?? false;
    state.routeLayout.isLike = isLike ?? false;
    state.routeLayout.isNav = isNav ?? false;
    state.routeLayout.isGlass = isGlass ?? false;
    state.routeLayout.isSearchHeader = isSearchHeader ?? false;
    state.routeLayout.isFilter = isFilter ?? false;
    state.routeLayout.isShare = isShare ?? false;
    state.routeLayout.isAnnouncementShare = isAnnouncementShare ?? false;
    state.routeLayout.isFuneralShare = isFuneralShare ?? false;
    state.routeLayout.isFuneralKakaoShare = isFuneralKakaoShare ?? false;
    state.routeLayout.isAnnouncementKakaoShare = isAnnouncementKakaoShare ?? false;

    state.routeLayout.isSmileShare = isSmileShare ?? false;
    state.routeLayout.isSmileKakaoShare = isSmileKakaoShare ?? false;
    state.routeLayout.isInvitationShare = isInvitationShare ?? false;
    state.routeLayout.isInvitationKakaoShare = isInvitationKakaoShare ?? false;

    state.routeLayout.isMemorialShare = isMemorialShare ?? false;
    state.routeLayout.isMemorialKakaoShare = isMemorialKakaoShare ?? false;
    state.routeLayout.isBusinessLike = isBusinessLike ?? false;
    state.routeLayout.isBusinessSubscribe = isBusinessSubscribe ?? false;
    state.routeLayout.isBusinessKakaoShare = isBusinessKakaoShare ?? false;
    state.routeLayout.isBusinessShare = isBusinessShare ?? false;
    state.routeLayout.isBizDetailShare = isBizDetailShare ?? false;
    state.routeLayout.isBusinessMarketingKakaoShare = isBusinessMarketingKakaoShare ?? false;
    state.routeLayout.isBusinessMarketingShare = isBusinessMarketingShare ?? false;
    state.routeLayout.isBusinessDonationShare = isBusinessDonationShare ?? false;
    state.routeLayout.isBusinessDonationKakaoShare = isBusinessDonationKakaoShare ?? false;
    state.routeLayout.isBusinessJobKakaoShare = isBusinessJobKakaoShare ?? false;
    state.routeLayout.isBusinessJobShare = isBusinessJobShare ?? false;
    state.routeLayout.isExcel = isExcel ?? false;
    state.routeLayout.subName = subName ?? '';
    state.routeLayout.isBell = isBell ?? false;
    state.routeLayout.isSetting = isSetting ?? false;
    state.routeLayout.isFooter = isFooter ?? false;
    state.routeLayout.isPlus = isPlus ?? false;
    state.routeLayout.isEdit = isEdit ?? false;
    state.routeLayout.isDelete = isDelete ?? false;
    state.routeLayout.isGreen = isGreen ?? false;

    if (!!isSearch) state.routeLayout.isSearch = isSearch;
  },
  setKeywords(state, { keywords = [] }) {
    state.keywords = JSON.stringify(keywords);
    localStorage.keywords = JSON.stringify(keywords);
  },
  memorizeScroll(state, scrolls = []) {
    state.scroll = scrolls;
  },
  appendScroll(state, scroll = {}) {
    state.scroll = [...state.scroll, scroll];
  },
  keepingAlive(state, keepAlive = []) {
    state.keepAlive = keepAlive;
  },
  setIsHeader(state, status) {
    state.routeLayout.isHeader = status;
  },
  setIsNav(state, isNav) {
    state.routeLayout.isNav = isNav;
  },
  setTitleName(state, titleName) {
    state.routeLayout.titleName = titleName;
  },
  setBottomSheet(state, bottomSheet = null) {
    state.bottomSheet = bottomSheet;
  },
  setIsFloating(state, isFloating = false) {
    state.isFloating = isFloating;
  },
  // 261012 기관 템플릿 회원 표식 — ServiceLanding 이 판정 뒤에, 로그아웃이 false 로
  setOrgNav(state, on = false) {
    state.orgNav = !!on;
  },
  // 261019 주차판 홈 회원 표식(홈·알림·마이 3탭) — ServiceLanding 이 판정 뒤에, 로그아웃이 false 로
  setParkingNav(state, on = false) {
    state.parkingNav = !!on;
  },
  // 261020 회원이 간판ON 화면을 둘러보는 동안 원래 탭바 — ServiceLanding 이 돌아가기 동그라미(memberBack)를 따라, 로그아웃이 false 로
  setMemberBrowse(state, on = false) {
    state.memberBrowse = !!on;
  },
  setIsHamburger(state, isHamburger = false) {
    state.isHamburger = isHamburger;
  },
  setIsWellFloating(state, isWellFloating = false) {
    state.isWellFloating = isWellFloating;
  },
  setIsBackFromSearch(state, isBackFromSearch) {
    state.isBackFromSearch = isBackFromSearch
  },
  setIsTodayExpireDate(state, isTodayExpireDate) {
    state.isTodayExpireDate = isTodayExpireDate
  },
  setIsIntroEnter(state, isIntroEnter) {
    state.isIntroEnter = isIntroEnter
  },
  setFormDirty(state, formDirty) {
    state.formDirty = formDirty
  },
  // 260609 리뉴얼: 메인 소비자/사업자 모드 토글. localStorage 영속.
  setHomeMode(state, homeMode) {
    state.homeMode = homeMode;
    try { localStorage.setItem('homeMode', homeMode); } catch (e) { /* storage 차단 환경 무시 */ }
  }
};
